import PropTypes from 'prop-types';

var propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    subtitle: PropTypes.node,
    icon: PropTypes.object,
    onClick: PropTypes.func,
    buttonProps: PropTypes.object,
    rightText: PropTypes.node,
    disabled: PropTypes.bool,
    checkbox: PropTypes.bool,
    radio: PropTypes.bool,
    checked: PropTypes.bool,
    arrow: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
    leftElement: PropTypes.node,
    className: PropTypes.string,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    buttonProps: {},
};

export { defaultProps, propTypes };
